import { Observable } from 'rxjs/internal/Observable'
import { shareLatest } from 'utils/rx-util'
import { map } from 'rxjs/operators'
import { APIConfig } from 'types/definitions'
import { firstValueFrom } from 'rxjs'

/**
 * gRPC authentication metadata.
 */
export interface IMeta {
  [key: string]: string
  Authorization: string
}

/**
 * Authenticator for use with gRPC APIs.
 */
export interface IGrpcAuthenticator {
  /**
   * Retrieves authentication meta information.
   */
  getMeta(): Promise<IMeta>

  /**
   * Authentication metadata stream.
   */
  meta$: Observable<IMeta>
}

/**
 * Creates an authenticator for use by gRPC APIs.
 */
export function createGrpcAuthenticator(config: APIConfig): IGrpcAuthenticator {
  const meta$ = config.token$.pipe(
    map((token) => ({ Authorization: `Bearer ${token}` })),
    shareLatest(),
  )

  return {
    meta$,

    getMeta() {
      return firstValueFrom(meta$)
    },
  }
}
